import React from 'react';
import { PageWrapper, HelmetWrap } from './../../components';

export default function Contact(props) {
  const ContactItems = props.data.contact_items.map((item, i) =>
    <li className={'contact-item'} id={'contact-item-' + i} key={'contact-item-' + i}>
      <div className='contact-item-title'><span className='primary'>{item.contact_label}</span> <span className='secondary'>{item.contact_label_secondary}</span></div>
      {item.emails.map((subitem, i) =>
        <a className='contact-email' href={'mailto:' + subitem.email} key={i}>{subitem.email}</a>
      )}
    </li>
  );
  return (
    <PageWrapper pageId={'page-about'}>
      <HelmetWrap pageMeta={props.data.page_meta} />
      <section className='contact-section'>
        <h3>{props.data.contact_title}</h3>
        <ul className='contact-list'>
          {ContactItems}
        </ul>
      </section>
    </PageWrapper>
  );
};



// WEBPACK FOOTER //
// ./src/pages/about/Contact.js